var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "language-icon",
    transform: "translate(-492 -612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36056",
    "data-name": "Path 36056",
    d: "M508,1237a8,8,0,0,1,16,0,6.27,6.27,0,0,1-.261,1.87,2.046,2.046,0,0,1-.485.85,1.016,1.016,0,0,1-.754.28.906.906,0,0,1-.73-.25,2.258,2.258,0,0,1-.482-1.1A29.735,29.735,0,0,1,521,1233a1,1,0,0,0-2,0,5,5,0,1,0,.751,7.31,3.291,3.291,0,0,0,.589.84,2.886,2.886,0,0,0,2.16.85,3.012,3.012,0,0,0,2.136-.83,4.064,4.064,0,0,0,1-1.67,8.21,8.21,0,0,0,.364-2.49V1237a9.994,9.994,0,1,0-5.555,8.96,1,1,0,0,0,.451-1.34.992.992,0,0,0-1.341-.45A8.005,8.005,0,0,1,508,1237Zm11,0a3,3,0,1,1-3-3A3,3,0,0,1,519,1237Z",
    transform: "translate(0 -601)",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4691",
    "data-name": "Rectangle 4691",
    width: 46,
    height: 46,
    rx: 23,
    transform: "translate(493 613)",
    fill: "none",
    stroke: "#32d7be",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLanguageIcon);
export default __webpack_public_path__ + "static/media/circleLanguageIcon.00445f266c6a98a8aa6adce883333083.svg";
export { ForwardRef as ReactComponent };